import type { useRouter } from '@tanstack/react-router';
import { useAuth } from '@vizit/auth';
import { LoginError } from '@vizit/organisms';
import * as React from 'react';
import { useAnalytics } from '../analytics';

type Router = Pick<ReturnType<typeof useRouter>, 'navigate'>;

export function useExpireSession() {
  const { onRemoveAuthentication } = useAuth();
  const { onClearSession } = useAnalytics();

  return React.useCallback(
    async (router: Router, href: string) => {
      const isReturnable = Boolean(href) && href !== '/' && !href.startsWith('/login');

      try {
        await onRemoveAuthentication();
      } finally {
        onClearSession();

        router.navigate({
          to: '/login',
          search: {
            error: LoginError.SessionExpired,
            redirect: isReturnable ? href : undefined,
          },
        });
      }
    },
    [onRemoveAuthentication, onClearSession],
  );
}
